import "pixi";
import "phaser";
import * as i18n from "../i18n";
import * as logging from "../logging";
import BackButton from "../ui/back";

import { BlurX, BlurY } from "../effects/blur";

export default class CongratulationsState extends Phaser.State {
    bg: Phaser.Sprite;
    title: i18n.Text;
    titleMask: Phaser.Graphics;
    thanks: i18n.Text;
    us: i18n.Text;
    back: BackButton;

    create() {
        this.game.stage.backgroundColor = "#FFFFFF";
        logging.startLevel(logging.LEVEL_CONGRATULATIONS, null);
        this.bg = this.game.add.sprite(0, 0, "background2");
        this.bg.width = this.game.width;
        this.bg.height = this.game.height;

        this.back = new BackButton(this.game, () => {
            logging.finishLevel();
            this.state.start("title", true, false, true);
        });
        this.back.enable();

        this.titleMask = this.game.add.graphics(0, 0);
        let mask = { width: 0 }
        const updateMask = () => {
            this.titleMask.clear();
            this.titleMask.beginFill(0xFFFFFF);
            this.titleMask.drawRect(0, 0, mask.width, this.game.height);
        };

        this.title = i18n.label(this.game, this.game.width / 2, 128, i18n._("CONGRATULATIONS"), "font-large", 88);
        this.title.anchor.set(0.5, 0);
        this.title.mask = this.titleMask;

        this.thanks = i18n.label(this.game, this.game.width / 2, 128 + i18n.labelHeight(this.title) + 64, i18n._("Thank you for playing!"), "font-large", 48);
        this.thanks.anchor.set(0.5, 0);

        this.us = i18n.label(
            this.game, this.game.width / 2, 128 + i18n.labelHeight(this.title) + 64 + i18n.labelHeight(this.thanks) + 48,
            i18n._("Developed By:\nCrystal Liu, Yuhan Wu, \nMichael Mauer, David Li, \nJoel Hover, and Tomasz Chmielewski"),
            "font-small", 32);
        this.us.anchor.set(0.5, 0);
        this.us.align = "center";

        const group = this.game.add.group();
        group.add(this.thanks);
        group.add(this.us);
        group.alpha = 0;
        group.position.y = this.game.height;

        const emitter = this.game.add.emitter(this.game.width / 2, this.game.height, 75);
        emitter.makeParticles("victory-star");
        emitter.minParticleSpeed.setTo(-300, -1500);
        emitter.maxParticleSpeed.setTo(300, -1000);
        emitter.minParticleScale = 0.1;
        emitter.maxParticleScale = 0.8;
        emitter.gravity.setTo(0, 1000);

        updateMask();
        this.game.add.tween(mask).to({
            width: this.game.width,
        }, 1000, Phaser.Easing.Cubic.In)
            .onUpdateCallback(updateMask)
            .start()
            .chain(
                this.game.add.tween(group).to({
                    alpha: 1,
                    y: 0,
                }, 500, Phaser.Easing.Cubic.InOut).delay(750)
            )
            .onComplete.add(() => {
                emitter.start(true, 10000, 0, 75);
                updateMask();
                this.bg.alpha = 0.5;
                this.game.add.tween(this.bg).to({
                    alpha: 1
                }, 500, Phaser.Easing.Cubic.In).start();
            });
    }
}



// WEBPACK FOOTER //
// ./src/states/congrats.ts